import { createAction } from '@ngrx/store';

export const openSpinner = createAction('[Loader] Open Spinner');
export const closeSpinner = createAction('[Loader] Close Spinner');
